import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent21 from "../../../assets/Sub-component/CoreComponent21";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import WebDesignCore from "../../../assets/Sub-component/WebDesignCore";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";

import cusotm from "../../../assets/Services/Web_design/Partner_with/custom_web.svg";
import ecom from "../../../assets/Services/Web_design/Partner_with/Ecom_web.svg";
import mobile from "../../../assets/Services/Web_design/Partner_with/mobile_app_design.svg";
import uiuxs from "../../../assets/Services/Web_design/Partner_with/UIUX.svg";
import webspeed from "../../../assets/Services/Web_design/Partner_with/Web_speed.svg";
import wordpress from "../../../assets/Services/Web_design/Partner_with/wordpress_web.svg";

import bug from "../../../assets/Services/Web_design/Why_choose/Bug_free.svg";
import code from "../../../assets/Services/Web_design/Why_choose/code.svg";
import customize from "../../../assets/Services/Web_design/Why_choose/Customize.svg";
import dynami from "../../../assets/Services/Web_design/Why_choose/Dynamic_market.svg";
import { Link } from "react-router-dom";

import icon from "../../../assets/Services/Web_design/Img.png";
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";
const WebDesign = () => {
   const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const content100 = [
    {
      icon: dynamic,
      title: "Responsive Web Design",
      desc: "By building a powerful website that rules the digital space, we optimize your company's engagement. Raiden makes sure your website works on desktops and mobile devices, ensuring that the user interface is accurate and functional.",
    },
    {
      icon: resposnsive,
      title: "Custom Web Design",
      desc: "We distinguish your company from all of the others in a crowded online market. Our useful web design produces a sophisticated visual identity and user interaction that seamlessly correlates with your business's values and target market.",
    },
    {
      icon: WebDesigns,
      title: "Dynamic Website Design",
      desc: "Raiden's dynamic design enables advanced features, personalized user experiences, and real-time content updates. This adaptability is essential for managing information, interacting with businesses, and capturing visitors' attention.",
    },
  ];

  const innovative = {
    maintitle: "Why Choose Raiden for Web Design services",
    maindesc:
      "A website is your core digital asset. We build more than sites; we build strategic platforms. Raiden focuses on precision, performance, and purpose in every project.",

    loop: [
      {
        icon: bug,
        title: "Customized for You",
        desc: "We offer a range of choices for creating your area so you can interact with your target audience and maintain your position at the top. Our service offers an intuitive user interface and boosts engagement for your unique success. ",
      },
      {
        icon: code,
        title: "Dynamic Marketing",
        desc: "With our cutting-edge tools and adaptable approaches, businesses benefit from our dynamic marketing strategies. For a very engaging experience that increases conversions, anticipate real-time interaction and personalized content.",
      },

      {
        icon: customize,
        title: "Powerful, Seamless Code",
        desc: "Raiden produces solid programming that is dependable, efficient, and easy to understand. This is the driving force behind business growth, security, and performance. ",
      },

      {
        icon: dynami,
        title: "Bug-Free Reliability",
        desc: "Our rigorous testing ensures all applications are bug-free, preventing glitches. This means your audience gets uninterrupted, reliable access. Allegiance is strengthened and trust is established through a smooth and valuable experience.",
      },
    ],
  };

  const vertical = [
    {
      icon: cusotm,
      title: "custom web Design",
      line: "line-hori",
    },
    {
      icon: ecom,
      title: "UX/UI Design",
      line: "line-hori",
    },
    {
      icon: mobile,
      title: "Mobile App Design",
      line: "line-hori",
    },
    {
      icon: uiuxs,
      title: "E-Commerce Website Design",
      line: "line-hori",
    },
    {
      icon: webspeed,
      title: "WordPress Website Design",
      line: "line-hori",
    },

    {
      icon: wordpress,
      title: "Website Speed Optimization",
    },
  ];
  const handleClick=(e)=>{
    
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
    console.log("data submitted successfully")
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="overflow-hidden main-page-wrapper">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div className=" container">
        <div
          className=" row  min-vh-100 align-items-center topheader-margin"
           
        >
          <div className="col-lg-6">
            <h1 className="h1-heading lh-sm me-5 text-center text-lg-start mb-3 lh-base">
              UI and UX Design
            </h1>
            <p className="h1-para lh-base me-lg-5 mb-3 lh-base">
              We offer comprehensive web design services that are customized to
              satisfy the various demands of individuals and companies operating
              in 15 different countries.
            </p>
            <div className="d-flex ">
              <Link to="/request-quote">
                <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
                  Get Your Free Quote
                </button>
              </Link>
            </div>
          </div>

          <Contact/>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb">
            <h2 className="col-lg-6 h2-heading lh-sm mb-2 mb-lg-0">
              Raiden: Crafting Responsive, Custom, and Dynamic Web Solutions
            </h2>
            <p className="col-lg-6 h1-para lh-base">
              Raiden offers a powerful online presence by means of an effective
              website that is not only visually appealing but also dependable
              and usable by all users.
            </p>
          </div>

          <div className="">
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 marb ">
        <div className=" row">
          <div className="col-lg-6 text-center">
            <img src={icon} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base ">
              Crafting Your Digital Presence with Raiden's Expertise
            </h2>
            <p className="mt-lg-4 mt-2  h1-para lh-base">
              We at Raiden are creating your most potent online asset, not just
              websites. Our dedication to efficiency translates into scalable
              solutions, strong security, optimized performance, and simplified
              project management. Raiden has 10 years of experience in services
              for professionals, e-commerce businesses, SMBs, and service
              industries. We make sure that every design, from conception to
              continuing support, promotes long-term success.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart">
        <WebDesignCore vertical={vertical} />
      </div>

      <div className="container mt-80 mart">
        <CoreComponent21 innovative={innovative} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className="h2-heading lh-base ">
          Mastering the Full Spectrum of Web Design
        </h2>
        <p className="my-lg-3 my-2  h1-para lh-base ">
          Excellence and Successful Execution
        </p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WebDesign;
